export default __webpack_public_path__ + "static/media/filters-icon.b6376745.svg";